import React, { } from 'react';
import { useParams } from 'react-router-dom';
import PageLayout from '../../../components/PageLayout';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Action, CollectionServer, DropdownAction, Field, GET, GetMetaProperties, JSXMap, Model, POST, QueryParam, SetMetaProperties, deleteInArray, deleteInProperties, errorCatch, foreachInProperties, getObjectDisplay, updateInArray, updateInPropertiesUUID, useAuth, useMetaContext } from 'fennec-ui';
import { useOrganizerContext, useSchoolContext, useTeacherContext } from '../../../../common/Context';
import { Empty, message, Spin } from 'antd';
import ObjectOwnerDescription from '../../../../fedance-ui/ObjectOwnerDescription';
import confirmKey from '../../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';

var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Settings(props) {
    let { id } = useParams();
    const auth = useAuth();
    const meta = useMetaContext();

    // const sourceKey = "promouter";
    // const [event, setEvent] = useState(undefined);
    // useEffect(() => {
    //     GET(auth, `/api/meropriyatiya/list/${sourceKey}?detail=model&w-id=${id}`,
    //         ({ data }) => {
    //             if (data && data.length) {
    //                 setEvent(data[0]);
    //             }
    //         }, errorCatch);
    // }, [])

    const [school, setSchool] = useSchoolContext()
    const osnovi = _.get(school, "osnoviPromokodovShkolaFederatsii[0]")

    // "/api/emailshkol/create"
    // "/api/emailshkol/update"
    // "/api/emailshkol/delete/{id}"
    // "/api/emailshkol/list/{shkolaID}"
    // "/api/emailshkol/byid/{id}"
    // "/api/telefonishkol/create"
    // "/api/telefonishkol/update"
    // "/api/telefonishkol/delete/{id}"
    // "/api/telefonishkol/list/{shkolaID}"
    // "/api/telefonishkol/byid/{id}"
    // "/api/saitishkol/create"
    // "/api/saitishkol/update"
    // "/api/saitishkol/delete/{id}"
    // "/api/saitishkol/list/{shkolaID}"
    // "/api/saitishkol/byid/{id}"
    // "/api/adresashkol/create"
    // "/api/adresashkol/update"
    // "/api/adresashkol/delete/{id}"
    // "/api/adresashkol/list/{shkolaID}"
    // "/api/adresashkol/byid/{id}"

    let metaEmailShkol = _.get(meta, "EmailShkol");
    let metatelefonishkol = _.get(meta, "TelefoniShkol");
    let metasaitishkol = _.get(meta, "SaitiShkol");
    let metaadresashkol = _.get(meta, "AdresaShkol");

    const propertiesFromMeta = React.useCallback((name, funcs) => {
        let prop = [];
        // let p = _.get(meta[name], "properties");
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Creator", "ID"])
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);
    const filtersFromMeta = React.useCallback((name, funcs) => {
        let prop = [];
        // let p = _.get(meta[name], "properties");
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Creator", "ID"])
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);
    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;
        if (!obj) { return obj }
        let p = GetMetaProperties(obj)
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])
        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }
        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        p = foreachInProperties(p, n => (n.name == "Kommentarii"), {
            type: "text"
        })

        return SetMetaProperties(obj, p)
    }

    // console.log(filtersFromMeta(metasaitishkol.name, [
    //     (p) => { return deleteInProperties(p, ["Shkola"]) }
    // ]));
    // console.log(filtersFromMeta(metaadresashkol.name, [
    //     (p) => { return deleteInProperties(p, ["Shkola"]) }
    // ]));

    return (
        <PageLayout hideSider={false}>
            <div style={{ backgroundColor: "white", padding: "4px 15px", borderRadius: "4px" }}>
                <div className='pb-4'>
                    <div>
                        <div style={{ fontSize: "16px" }}>Информация о школе</div>
                    </div>
                    <div style={{ borderLeft: "2px solid #dee2e5", padding: "3px 3px 3px 17px" }}>
                        <div>Региональное отделение:
                            <span style={{ fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}> {school?.regionalnoeOtdelenie?.nazvanie}</span>
                        </div>
                    </div>
                    <div style={{ borderLeft: "2px solid #dee2e5", padding: "3px 3px 3px 17px" }}>
                        {school?.vseTipiPolzovatelei?.filter(e => e?.tipPolzovatelyaID == 18)?.map(e => {
                            return (<div>Владелец:
                                <span style={{ fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}> {e?.user?.lastname} {e?.user?.firstname}</span>
                            </div>)
                        })}
                    </div>
                    <div style={{ borderLeft: "2px solid #dee2e5", padding: "3px 3px 3px 17px" }}>
                        <div>Администраторы: </div>
                        <div style={{ padding: "3px 3px 3px 17px", fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}>
                            {school?.vseTipiPolzovatelei?.filter(e => e?.tipPolzovatelyaID == 19)?.map(e => {
                                return (<div>{e?.user?.lastname} {e?.user?.firstname}</div>)
                            })}
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <div style={{ fontSize: "16px" }}>Параметры промокодов</div>
                        {/* <div style={{ color: "rgb(140, 152, 164)", fontSize: "12px" }}>
                            Параметры промокодов
                        </div> */}
                    </div>
                    <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                        <Action
                            auth={auth}
                            okText="Сохранить"
                            action={(values, unlock, close) => {
                                // "/api/osnovipromokodov/new"
                                // "/api/osnovipromokodov/update"
                                // "/api/osnovipromokodov/delete"
                                if (values?.osnovaPromokoda && values?.osnovaPromokoda !== "") {
                                    POST(auth, (!osnovi) ? `/api/osnovipromokodov/new` : `/api/osnovipromokodov/update`, {
                                        ID: (osnovi) ? osnovi.ID : undefined,
                                        prepodavatelShkoliID: undefined,
                                        shkolaFederatsiiID: school?.ID,
                                        prepodavatelFederatsiiID: undefined,
                                        organizatorFederatsiiID: undefined,
                                        osnovaPromokoda: values?.osnovaPromokoda,
                                    }, ({ data }) => {
                                        setSchool({ ...school, osnoviPromokodovShkolaFederatsii: updateInArray(school?.osnoviPromokodovShkolaFederatsii, data) })
                                        close()
                                    }, (err) => errorCatch(err, () => unlock()))
                                } else if (osnovi) {
                                    POST(auth, `/api/osnovipromokodov/delete`, {
                                        ID: (osnovi) ? osnovi.ID : undefined,
                                        prepodavatelShkoliID: undefined,
                                        shkolaFederatsiiID: school?.ID,
                                        prepodavatelFederatsiiID: undefined,
                                        organizatorFederatsiiID: undefined,
                                        osnovaPromokoda: values?.osnovaPromokoda,
                                    }, ({ data }) => {
                                        setSchool({ ...school, osnoviPromokodovShkolaFederatsii: [] })
                                        close()
                                    }, (err) => errorCatch(err, () => unlock()))
                                }

                            }}

                            object={osnovi}
                            disabledOkOnUncahngedForm={true}

                            form={Model}
                            meta={[
                                {
                                    label: "Основа промокода",
                                    description: (<span><i className="fa fa-question-circle"></i> Применяется в качестве префикса при выдаче промокода организатором мероприятия</span>),
                                    name: "osnovaPromokoda",
                                    type: "string",
                                    size: "small"
                                }
                            ]}
                            mode={"inline"}
                        />
                    </div>
                </div>
                <div style={{ marginTop: "20px" }}>
                    <div>
                        <div style={{ fontSize: "16px" }}> Параметры школы</div>
                        {/* <div style={{ color: "rgb(140, 152, 164)", fontSize: "12px" }}>
                            Параметры школы
                        </div> */}
                    </div>
                    <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                        <Action
                            auth={auth}
                            okText="Сохранить"
                            action={(values, unlock, close) => {
                                POST(auth, `/api/school/update`, {
                                    ...school,
                                    ...values
                                }, ({ data }) => {
                                    setSchool({ ...school, ...data })
                                    close()
                                }, (err) => errorCatch(err, () => unlock()))
                            }}

                            object={school}
                            disabledOkOnUncahngedForm={true}

                            form={Model}
                            meta={[
                                {
                                    label: "Название школы",
                                    // description: (<span><i className="fa fa-question-circle"></i>  Создавать промокоды преподавателям школы</span>),
                                    name: "nazvanieShkoliTantsev",
                                    type: "string",
                                    size: "small"
                                },
                                {
                                    label: "Школа второго уровня",
                                    // description: (<span><i className="fa fa-question-circle"></i>  Создавать промокоды преподавателям школы</span>),
                                    name: "shkolaVtorogoUrovnya",
                                    type: "bool",
                                    size: "small"
                                },
                                {
                                    label: "Процент преподавателям ",
                                    description: (<span><i className="fa fa-question-circle"></i> Процент начисляемый преподавателю по промокоду</span>),
                                    name: "protsentSvoimPrepodavatelyam",
                                    type: "float",
                                    size: "small"
                                }
                            ]}
                            mode={"inline"}
                        />
                    </div>
                    {(school && metaEmailShkol) && <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                        <div className='bg bg-grey light-3' style={{ fontSize: "14px", fontWeight: "bold", textAlign: "left", marginBottom: "5px", padding: "0 5px" }}>Email</div>
                        <CollectionServer
                            auth={auth}
                            name={"EmailShkol"}
                            source={`/api/emailshkol/list/${school?.ID}`}
                            filters={() => []}
                            // filters={() => filtersFromMeta(metaEmailShkol.name, [
                            //     (p) => { return deleteInProperties(p, ["Shkola"]) }
                            //     // (p) => {
                            //     //     return foreachInProperties(p, n => (n.name == "Strana"), {
                            //     //         display: (item) => {
                            //     //             return item?.name
                            //     //         },
                            //     //     })
                            //     // }
                            // ])}
                            customRender={(items, {
                                collection,
                                setCollection,
                                setCollectionItem,
                                removeCollectionItem,
                                collectionActions,
                                modelActions,
                                update,
                                loading
                            }) => (
                                <Spin spinning={loading}>
                                    {!collection?.length && <div>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" />
                                    </div>}
                                    {(collection?.length > 0) && JSXMap(items, (item, idx) => {
                                        return (
                                            <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                                                <div style={{ flex: "1 1 auto" }}>
                                                    <div>{item?.email}</div>
                                                </div>
                                                <div style={{ flex: "0 0 25px" }}>
                                                    <DropdownAction
                                                        style={{ padding: "0" }}
                                                        button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                            <i className="fa fa-ellipsis-h"></i>
                                                        </div>)}
                                                        items={modelActions(item, idx)?.map((e, idx) => ({
                                                            key: e.key || idx,
                                                            auth: auth,
                                                            mode: "MenuItem",
                                                            object: item,
                                                            collection: collection,
                                                            setCollection: setCollection,
                                                            ...e
                                                        }))} />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </Spin>
                            )}
                            size={"small"}
                            mode="list"
                            linksModelActions={"inline"}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return [{
                                    auth: auth,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/emailshkol/create`, { ...values, shkolaID: school?.ID },
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    title: "Создать",
                                    form: Model,
                                    meta: propertiesFromMeta(metaEmailShkol.name, [
                                        (p) => { return deleteInProperties(p, ["Shkola"]) }
                                    ])
                                }]
                                // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                            }}
                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return [
                                    {
                                        action: (values, unlock, close, { collection, setCollection }) => {
                                            POST(auth, `/api/emailshkol/update`, { ...values, ID: item?.ID, shkolaID: school?.ID },
                                                ({ data }) => {
                                                    setCollection(updateInArray(collection, data));
                                                    close();
                                                }, (err) => errorCatch(err, unlock)
                                            );
                                        },
                                        object: item,
                                        form: Model,
                                        meta: propertiesFromMeta(metaEmailShkol.name, [
                                            (p) => { return deleteInProperties(p, ["Shkola"]) }
                                        ]),
                                        title: "Изменить",
                                    },
                                    {
                                        title: <span style={{ color: "red" }}>Удалить</span>,
                                        action: (values, unlock, close, { collection, setCollection }) => {
                                            confirmKey({
                                                pass: '123',
                                                title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить email</span>,
                                                icon: undefined,
                                                content: <div>
                                                    <div><span>Вы действительно хотите удалить email?</span></div>
                                                    <div>
                                                        <span style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                                            {item?.email}
                                                        </span>
                                                    </div>
                                                </div>,
                                                okText: 'Удалить',
                                                cancelText: 'Отмена',
                                                onOk() {
                                                    return new Promise((resolve, reject) => {
                                                        GET(auth, `/api/emailshkol/delete/${item.ID}`,
                                                            ({ data }) => {
                                                                message.success('Готово');
                                                                setCollection(deleteInArray(collection, item))
                                                                resolve(data);
                                                            }, (err) => errorCatch(err, reject));
                                                    }).catch(() => { });
                                                },
                                                onCancel() {
                                                },
                                            })
                                        },
                                    }
                                ]
                                // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                            }}
                        />
                    </div>}
                    {(school && metatelefonishkol) && <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                        <div className='bg bg-grey light-3' style={{ fontSize: "14px", fontWeight: "bold", textAlign: "left", marginBottom: "5px", padding: "0 5px" }}>Телефоны</div>
                        <CollectionServer
                            auth={auth}
                            name={"TelefoniShkol"}
                            source={`/api/telefonishkol/list/${school?.ID}`}
                            filters={() => []}
                            // filters={() => filtersFromMeta(metatelefonishkol.name, [
                            //     (p) => { return deleteInProperties(p, ["Shkola"]) }
                            //     // (p) => {
                            //     //     return foreachInProperties(p, n => (n.name == "Strana"), {
                            //     //         display: (item) => {
                            //     //             return item?.name
                            //     //         },
                            //     //     })
                            //     // }
                            // ])}
                            customRender={(items, {
                                collection,
                                setCollection,
                                setCollectionItem,
                                removeCollectionItem,
                                collectionActions,
                                modelActions,
                                update,
                                loading
                            }) => (
                                <Spin spinning={loading}>
                                    {!collection?.length && <div>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" />
                                    </div>}
                                    {(collection?.length > 0) && JSXMap(items, (item, idx) => {
                                        return (
                                            <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                                                <div style={{ flex: "1 1 auto" }}>
                                                    <div>{item?.nomer}</div>
                                                </div>
                                                <div style={{ flex: "0 0 25px" }}>
                                                    <DropdownAction
                                                        style={{ padding: "0" }}
                                                        button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                            <i className="fa fa-ellipsis-h"></i>
                                                        </div>)}
                                                        items={modelActions(item, idx)?.map((e, idx) => ({
                                                            key: e.key || idx,
                                                            auth: auth,
                                                            mode: "MenuItem",
                                                            object: item,
                                                            collection: collection,
                                                            setCollection: setCollection,
                                                            ...e
                                                        }))} />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </Spin>
                            )}
                            size={"small"}
                            mode="list"
                            linksModelActions={"inline"}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return [{
                                    auth: auth,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/telefonishkol/create`, { ...values, shkolaID: school?.ID },
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    title: "Создать",
                                    form: Model,
                                    meta: propertiesFromMeta(metatelefonishkol.name, [
                                        (p) => { return deleteInProperties(p, ["Shkola"]) }
                                    ])
                                }]
                                // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                            }}
                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return [
                                    {
                                        action: (values, unlock, close, { collection, setCollection }) => {
                                            POST(auth, `/api/telefonishkol/update`, { ...values, ID: item?.ID, shkolaID: school?.ID },
                                                ({ data }) => {
                                                    setCollection(updateInArray(collection, data));
                                                    close();
                                                }, (err) => errorCatch(err, unlock)
                                            );
                                        },
                                        object: item,
                                        form: Model,
                                        meta: propertiesFromMeta(metatelefonishkol.name, [
                                            (p) => { return deleteInProperties(p, ["Shkola"]) }
                                        ]),
                                        title: "Изменить",
                                    },
                                    {
                                        title: <span style={{ color: "red" }}>Удалить</span>,
                                        action: (values, unlock, close, { collection, setCollection }) => {
                                            confirmKey({
                                                pass: '123',
                                                title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить телефон</span>,
                                                icon: undefined,
                                                content: <div>
                                                    <div><span>Вы действительно хотите удалить телефон?</span></div>
                                                    <div>
                                                        <span style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                                            {item?.nomer}
                                                        </span>
                                                    </div>
                                                </div>,
                                                okText: 'Удалить',
                                                cancelText: 'Отмена',
                                                onOk() {
                                                    return new Promise((resolve, reject) => {
                                                        GET(auth, `/api/telefonishkol/delete/${item.ID}`,
                                                            ({ data }) => {
                                                                message.success('Готово');
                                                                setCollection(deleteInArray(collection, item))
                                                                resolve(data);
                                                            }, (err) => errorCatch(err, reject));
                                                    }).catch(() => { });
                                                },
                                                onCancel() {
                                                },
                                            })
                                        },
                                    }
                                ]
                                // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                            }}
                        />
                    </div>}
                    {(school && metasaitishkol) && <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                        <div className='bg bg-grey light-3' style={{ fontSize: "14px", fontWeight: "bold", textAlign: "left", marginBottom: "5px", padding: "0 5px" }}>Сайты</div>
                        <CollectionServer
                            auth={auth}
                            name={"SaitiShkol"}
                            source={`/api/saitishkol/list/${school?.ID}`}
                            filters={() => []}
                            // filters={() => filtersFromMeta(metasaitishkol.name, [
                            //     (p) => { return deleteInProperties(p, ["Shkola"]) },
                            //     (p) => {
                            //         return foreachInProperties(p, n => (n.name == "TipSeti"), {
                            //             display: (item) => {
                            //                 return item?.nazvanie
                            //             },
                            //         })
                            //     }
                            // ])}
                            customRender={(items, {
                                collection,
                                setCollection,
                                setCollectionItem,
                                removeCollectionItem,
                                collectionActions,
                                modelActions,
                                update,
                                loading
                            }) => (
                                <Spin spinning={loading}>
                                    {!collection?.length && <div>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" />
                                    </div>}
                                    {(collection?.length > 0) && JSXMap(items, (item, idx) => {
                                        return (
                                            <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                                                <div style={{ flex: "1 1 auto" }}>
                                                    <div>{item?.url}</div>
                                                </div>
                                                <div style={{ flex: "0 0 25px" }}>
                                                    <DropdownAction
                                                        style={{ padding: "0" }}
                                                        button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                            <i className="fa fa-ellipsis-h"></i>
                                                        </div>)}
                                                        items={modelActions(item, idx)?.map((e, idx) => ({
                                                            key: e.key || idx,
                                                            auth: auth,
                                                            mode: "MenuItem",
                                                            object: item,
                                                            collection: collection,
                                                            setCollection: setCollection,
                                                            ...e
                                                        }))} />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </Spin>
                            )}
                            size={"small"}
                            mode="list"
                            linksModelActions={"inline"}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return [{
                                    auth: auth,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/saitishkol/create`, { ...values, shkolaID: school?.ID },
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    title: "Создать",
                                    form: Model,
                                    meta: propertiesFromMeta(metasaitishkol.name, [
                                        (p) => { return deleteInProperties(p, ["Shkola"]) },
                                        (p) => {
                                            return foreachInProperties(p, n => (n.name == "TipSeti"), {
                                                display: (item) => {
                                                    return item?.nazvanie
                                                },
                                            })
                                        }
                                    ])
                                }]
                                // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                            }}
                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return [
                                    {
                                        action: (values, unlock, close, { collection, setCollection }) => {
                                            POST(auth, `/api/saitishkol/update`, { ...values, ID: item?.ID, shkolaID: school?.ID },
                                                ({ data }) => {
                                                    setCollection(updateInArray(collection, data));
                                                    close();
                                                }, (err) => errorCatch(err, unlock)
                                            );
                                        },
                                        object: item,
                                        form: Model,
                                        meta: propertiesFromMeta(metasaitishkol.name, [
                                            (p) => { return deleteInProperties(p, ["Shkola"]) },
                                            (p) => {
                                                return foreachInProperties(p, n => (n.name == "TipSeti"), {
                                                    display: (item) => {
                                                        return item?.nazvanie
                                                    },
                                                })
                                            }
                                        ]),
                                        title: "Изменить",
                                    },
                                    {
                                        title: <span style={{ color: "red" }}>Удалить</span>,
                                        action: (values, unlock, close, { collection, setCollection }) => {
                                            confirmKey({
                                                pass: '123',
                                                title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить сайт</span>,
                                                icon: undefined,
                                                content: <div>
                                                    <div><span>Вы действительно хотите удалить сайт?</span></div>
                                                    <div>
                                                        <span style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                                            {item?.url}
                                                        </span>
                                                    </div>
                                                </div>,
                                                okText: 'Удалить',
                                                cancelText: 'Отмена',
                                                onOk() {
                                                    return new Promise((resolve, reject) => {
                                                        GET(auth, `/api/saitishkol/delete/${item.ID}`,
                                                            ({ data }) => {
                                                                message.success('Готово');
                                                                setCollection(deleteInArray(collection, item))
                                                                resolve(data);
                                                            }, (err) => errorCatch(err, reject));
                                                    }).catch(() => { });
                                                },
                                                onCancel() {
                                                },
                                            })
                                        },
                                    }
                                ]
                                // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                            }}
                        />
                    </div>}
                    {(school && metaadresashkol) && <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                        <div className='bg bg-grey light-3' style={{ fontSize: "14px", fontWeight: "bold", textAlign: "left", marginBottom: "5px", padding: "0 5px" }}>Адреса</div>
                        <CollectionServer
                            auth={auth}
                            name={"AdresaShkol"}
                            source={`/api/adresashkol/list/${school?.ID}`}
                            filters={() => []}
                            // filters={() => filtersFromMeta(metaadresashkol.name, [
                            //     (p) => { return deleteInProperties(p, ["Shkola"]) }
                            //     // (p) => {
                            //     //     return foreachInProperties(p, n => (n.name == "Strana"), {
                            //     //         display: (item) => {
                            //     //             return item?.name
                            //     //         },
                            //     //     })
                            //     // }
                            // ])}
                            customRender={(items, {
                                collection,
                                setCollection,
                                setCollectionItem,
                                removeCollectionItem,
                                collectionActions,
                                modelActions,
                                update,
                                loading
                            }) => (
                                <Spin spinning={loading}>
                                    {!collection?.length && <div>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" />
                                    </div>}
                                    {(collection?.length > 0) && JSXMap(items, (item, idx) => {
                                        return (
                                            <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                                                <div style={{ flex: "1 1 auto" }}>
                                                    <div>{(!item?.gorod?.name) ? "" : "г. " + item?.gorod?.name + ", "}{item?.adres}</div>
                                                </div>
                                                <div style={{ flex: "0 0 25px" }}>
                                                    <DropdownAction
                                                        style={{ padding: "0" }}
                                                        button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                            <i className="fa fa-ellipsis-h"></i>
                                                        </div>)}
                                                        items={modelActions(item, idx)?.map((e, idx) => ({
                                                            key: e.key || idx,
                                                            auth: auth,
                                                            mode: "MenuItem",
                                                            object: item,
                                                            collection: collection,
                                                            setCollection: setCollection,
                                                            ...e
                                                        }))} />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </Spin>
                            )}
                            size={"small"}
                            mode="list"
                            linksModelActions={"inline"}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return [{
                                    auth: auth,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/adresashkol/create`, { ...values, shkolaID: school?.ID },
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    title: "Создать",
                                    form: Model,
                                    meta: propertiesFromMeta(metaadresashkol.name, [
                                        (p) => { return deleteInProperties(p, ["Shkola"]) }
                                    ])
                                }]
                                // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                            }}
                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return [
                                    {
                                        action: (values, unlock, close, { collection, setCollection }) => {
                                            POST(auth, `/api/adresashkol/update`, { ...values, ID: item?.ID, shkolaID: school?.ID },
                                                ({ data }) => {
                                                    setCollection(updateInArray(collection, data));
                                                    close();
                                                }, (err) => errorCatch(err, unlock)
                                            );
                                        },
                                        object: item,
                                        form: Model,
                                        meta: propertiesFromMeta(metaadresashkol.name, [
                                            (p) => { return deleteInProperties(p, ["Shkola"]) }
                                        ]),
                                        title: "Изменить",
                                    },
                                    {
                                        title: <span style={{ color: "red" }}>Удалить</span>,
                                        action: (values, unlock, close, { collection, setCollection }) => {
                                            confirmKey({
                                                pass: '123',
                                                title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить адрес</span>,
                                                icon: undefined,
                                                content: <div>
                                                    <div><span>Вы действительно хотите удалить адрес?</span></div>
                                                    <div>
                                                        <span style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                                            <div>{(!item?.gorod?.name) ? "" : "г. " + item?.gorod?.name + ", "}{item?.adres}</div>
                                                        </span>
                                                    </div>
                                                </div>,
                                                okText: 'Удалить',
                                                cancelText: 'Отмена',
                                                onOk() {
                                                    return new Promise((resolve, reject) => {
                                                        GET(auth, `/api/adresashkol/delete/${item.ID}`,
                                                            ({ data }) => {
                                                                message.success('Готово');
                                                                setCollection(deleteInArray(collection, item))
                                                                resolve(data);
                                                            }, (err) => errorCatch(err, reject));
                                                    }).catch(() => { });
                                                },
                                                onCancel() {
                                                },
                                            })
                                        },
                                    }
                                ]
                                // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                            }}
                        />
                    </div>}
                </div>
            </div>
        </PageLayout>
    );
}
